const $ = jQuery;

const tabbableQuery =
	"a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]";

export class NavigationSidebar {
	constructor({ navigation }) {
		this.isOpen = false;
		this.navigation = navigation;
		this.tabbableElements = this.navigation.find(tabbableQuery);
		this.search = this.navigation.find(
			'.main-navigation-sidebar__search input[type="search"]'
		);
		this.init();
	}

	/**
	 * Init settings in order for the menu to work as expected
	 */
	init() {
		// Sets tabindex to negative in order to prevent users from accessing the menu without the menu being open
		this.tabbableElements.attr("data-tabindexable", "");
		this.tabbableElements.attr("tabindex", -1);

		const length = this.tabbableElements.length;
		const $firstTabbableElement = $(this.tabbableElements[0]);
		const $lastTabbableElement = $(this.tabbableElements[length - 1]);

		// Go to the first tabbable element if user tabs on the last element
		$lastTabbableElement.on("keydown", function (e) {
			if (e.key === "Tab" && !e.shiftKey) {
				e.preventDefault();
				$firstTabbableElement.focus();
			}
		});

		// Go to the last tabbable element if user shift tabs on the first element
		$firstTabbableElement.on("keydown", function (e) {
			if (e.key === "Tab" && e.shiftKey) {
				e.preventDefault();
				$lastTabbableElement.focus();
			}
		});

		this.onToggle();
		window.navigationSidebar = this;
	}

	/**
	 * Toggle Main navigation.
	 */
	toggle() {
		this.isOpen ? this.close() : this.open();
	}

	/**
	 * Open Main navigation.
	 */
	open() {
		this.navigation.addClass("open");
		$("body").addClass("main-navigation-sidebar-active");
		this.isOpen = true;
		this.onToggle();
	}

	/**
	 * Close Main navigation.
	 */
	close() {
		this.navigation.removeClass("open");
		$("body").removeClass("main-navigation-sidebar-active");
		this.isOpen = false;
		this.onToggle();
	}

	// Handle toggle of the menu
	onToggle() {
		// Toggle tabindex on tabbable elements
		this.navigation
			.find("[data-tabindexable]")
			.attr("tabindex", !this.isOpen ? -1 : 0);

		// Toggles the aria-expanded attribute
		$(`[aria-controls="${this.navigation.attr("id")}"]`).attr(
			"aria-expanded",
			this.isOpen ? "true" : "false"
		);
	}
}
